import {
  Container,
  Text,
  TokenTextAppearance,
  TokenTextColor,
  TextTag,
  TextAlignment,
} from '@volkswagen-onehub/components-core';
import { ReactNode } from 'react';
import Superscript from '../Superscript/Superscript';
import { DropdownTextWrapper, TotalPriceWrapper, IndividualPriceWrapper } from './VehicleCard.styles';
import { useTribalContext } from '@/context/tribal';

export interface VehicleCardDropdownTextProps {
  summarisedView?: boolean;
  isMobileWidth: boolean;
  title: ReactNode;
  totalPriceLabel: ReactNode;
  carSummary: ReactNode;
  disabled: ReactNode;
  totalPrice: ReactNode;
  p11dPrice: ReactNode;
}

const VehicleCardDropdownText = ({
  summarisedView,
  isMobileWidth,
  title,
  totalPriceLabel,
  carSummary,
  disabled,
  totalPrice,
  p11dPrice,
}: VehicleCardDropdownTextProps) => {

  const { contentManager, analyticsManager, analyticsBuilder } =
    useTribalContext();

  return (
    <DropdownTextWrapper summarisedView={summarisedView}>
      <Container wrap="always" gutter="dynamic0020">
        <Text
          className='dropdown-text-wrapper-car-title'
          appearance={
            isMobileWidth && summarisedView
              ? TokenTextAppearance.headline200
              : TokenTextAppearance.headline200
          }
          color={TokenTextColor.primary}
          tag={TextTag.p}
          bold
        >
          {title}
        </Text>
        {!summarisedView && (
          <Text
            appearance={TokenTextAppearance.copy100}
            color={TokenTextColor.primary}
            tag={TextTag.p}
          >
            {carSummary}
          </Text>
        )}
      </Container>
      <TotalPriceWrapper>
       
        {!disabled && (
          <Text
            className='price-wrapper-fw'
            appearance={TokenTextAppearance.copy200}
            color={TokenTextColor.primary}
            tag={TextTag.div}
            //bold={!summarisedView}
            textAlign={isMobileWidth ? TextAlignment.left : TextAlignment.right}
            
          >
            
            <IndividualPriceWrapper className='individual-price-wrapper'>
              <span>{contentManager.get('total-price-label')}<Superscript /></span><strong>{totalPrice}</strong>
            </IndividualPriceWrapper>
            
            {p11dPrice && (
              <IndividualPriceWrapper className='individual-price-wrapper'>
                <span>{contentManager.get('p11d-price-label')}{' '}</span><strong>{p11dPrice}</strong>
              </IndividualPriceWrapper>
            )}
            
          </Text>
        )}

       
        

      </TotalPriceWrapper>
    </DropdownTextWrapper>
  );
};

export default VehicleCardDropdownText;
